import { FetchCountryRequestTypes } from '../actions/CountryActions';
const initialState = null;

const Country = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchCountryRequestTypes.RECEIVE:
      if (payload && payload.data) {
        return payload.data.country;
      }

      return state;

    default:
      return state;
  }
};

export default Country;